export const DataTypeActionRegistry = Symbol.for('DataTypeActionRegistry');
